// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-manager h1 {
  font-size: 32px;
  margin-bottom: 24px;
}

.orders-content {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 24px;
}

.orders-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.order-card {
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.order-card:hover {
  transform: translateX(4px);
}

.order-card.selected {
  border: 2px solid var(--primary-color);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.order-header h3 {
  font-size: 16px;
  margin-bottom: 4px;
}

.order-date {
  font-size: 14px;
  color: var(--text-light);
}

.order-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

.order-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-summary p {
  color: var(--text-dark);
}

.order-total {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
}

.order-details {
  padding: 24px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.order-details h2 {
  font-size: 24px;
  margin-bottom: 24px;
}

.detail-section {
  margin-bottom: 32px;
}

.detail-section h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: var(--primary-color);
}

.detail-row {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
}

.detail-row span:first-child {
  font-weight: 500;
  color: var(--text-light);
}

.detail-row .address {
  white-space: pre-line;
}

.status-select {
  padding: 8px 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.status-select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.order-item-detail {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 8px;
}

.item-name {
  font-weight: 600;
  margin-bottom: 4px;
}

.item-quantity {
  font-size: 14px;
  color: var(--text-light);
}

.item-price {
  font-weight: 700;
  color: var(--primary-color);
}

.order-total-row {
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 2px solid var(--border);
  font-size: 20px;
  font-weight: 700;
}

.order-total-row span:last-child {
  color: var(--primary-color);
}

@media (max-width: 768px) {
  .orders-content {
    grid-template-columns: 1fr;
  }

  .orders-list {
    max-height: 400px;
  }

  .detail-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/OrdersManager.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF","sourcesContent":[".orders-manager h1 {\n  font-size: 32px;\n  margin-bottom: 24px;\n}\n\n.orders-content {\n  display: grid;\n  grid-template-columns: 400px 1fr;\n  gap: 24px;\n}\n\n.orders-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.order-card {\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.order-card:hover {\n  transform: translateX(4px);\n}\n\n.order-card.selected {\n  border: 2px solid var(--primary-color);\n}\n\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.order-header h3 {\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n\n.order-date {\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.order-status {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.order-summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.order-summary p {\n  color: var(--text-dark);\n}\n\n.order-total {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n.order-details {\n  padding: 24px;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.order-details h2 {\n  font-size: 24px;\n  margin-bottom: 24px;\n}\n\n.detail-section {\n  margin-bottom: 32px;\n}\n\n.detail-section h3 {\n  font-size: 18px;\n  margin-bottom: 16px;\n  color: var(--primary-color);\n}\n\n.detail-row {\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  gap: 16px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.detail-row span:first-child {\n  font-weight: 500;\n  color: var(--text-light);\n}\n\n.detail-row .address {\n  white-space: pre-line;\n}\n\n.status-select {\n  padding: 8px 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.status-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.order-item-detail {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.item-name {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.item-quantity {\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n.item-price {\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n.order-total-row {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 16px;\n  margin-top: 16px;\n  border-top: 2px solid var(--border);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.order-total-row span:last-child {\n  color: var(--primary-color);\n}\n\n@media (max-width: 768px) {\n  .orders-content {\n    grid-template-columns: 1fr;\n  }\n\n  .orders-list {\n    max-height: 400px;\n  }\n\n  .detail-row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
